import { NgModule } from '@angular/core';
import { NgPrimeModule } from './app.ngprime.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgCalendarMaskModule } from './core/driectives/calendar_custom.directive';
import { CustomInputModule } from './core/driectives/custom_input.directive';
import { CustomInputMaskModule } from './core/driectives/custom_input_mask.directive';
import { CustomInputNumberModule } from './core/driectives/custom_inputnumber.directive';
//PDF Viewer
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
// Translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { CustomDropDownModule } from './core/driectives/custom_dropdown.directive';
import { CustomAutoCompleteModule } from './core/driectives/auto_complete.directive';
import { CustomTextAreaModule } from './core/driectives/custom_textarea.directive';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
    imports: [
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            isolate: false
        })
    ],
    exports: [
        NgPrimeModule,
        PdfJsViewerModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        PrimeNgCalendarMaskModule,
        CustomInputModule,
        CustomInputMaskModule,
        CustomDropDownModule,
        CustomAutoCompleteModule,
        CustomInputNumberModule,
        CustomTextAreaModule
    ],
    declarations:[
    ]
})
export class AppCommonModule {

}